import React from 'react';
import { Box } from '@landr/maestro';
import { useBpmAndKeys } from '../hooks/useBpmAndKeys';
import { KeysFilter } from './KeysFilter';

const BpmFiltersContent = ({ isMobile }: { isMobile: boolean }) => {
    const {
        keyrootnote,
        keyquality,
        toggleKeyQualityFilter,
        toggleKeyRootFilter,
    } = useBpmAndKeys();

    return (
        <Box width="100%">
            <KeysFilter
                keyrootnote={keyrootnote}
                keyquality={keyquality}
                toggleKeyRootFilter={toggleKeyRootFilter}
                toggleKeyQualityFilter={toggleKeyQualityFilter}
                isMobile={isMobile}
            />
        </Box>
    );
};

export default BpmFiltersContent;
